import React, { useState, useEffect, useCallback } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../common/component/LoaderProvider";
import { useFieldArray, useForm } from "react-hook-form";
import useValidation from "../../common/utils/validationRules";
import CommmonTable from "../../common/component/commonTable";
import { useToast } from "../../common/component/Toast";
import CommonButton from "../../common/component/commonButton";
import { useLocation } from "react-router-dom";
import StepperModal from "../../common/component/commonStepper";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import SearchLogo from "../../assests/images/Search.png";
import debounce from "lodash.debounce";
import {
  getRegion,
  getAsl,
} from "../../service/action/actioncreator/HospitalAction/Hospital";
import CommonTab from "../../common/component/commonTab";
import Search from "../../assests/images/add button.png";
import ConfirmAlert from "../../common/component/commonAlert";
import CommonLoader from "../../common/component/commonLoader";
import noData from "../../assests/images/no-record-found.png";
import {
  createHospitalRetail,
  getByRetailId,
  getPharmacyRetail,
  updateStatusRetail,
} from "../../service/action/actioncreator/RetailAction/Retail";
import HospitalRetailContact from "./HospitalRetailContact";
import DynamicBreadcrumbs from "../../common/component/breadcrumbs";
import FarmacieInsertionRetail from "./FarmacieInsertionRetail";
import { formatTime, formatDate, extractPhoneNumber } from "../../common/utils/commonFunction";
import RetailView from "./RetailView";

const HospitalRetail = () => {

  const pharmacyInfo = useSelector(
    (state) => state.retailReducer.retailPharamacyResponse
  );
  const pharmacyViewData = useSelector(
    (state) => state.retailReducer.retailGetIdResponse
  );

  const loading = useSelector(
    (state) => state.hospitalReducer.pharmacyListLoading
  );
  const regionDropdown = useSelector(
    (state) => state.hospitalReducer.regionListResponse
  );
  const aslRegionDropdown = useSelector(
    (state) => state.hospitalReducer.regionASLListResponse
  );
  const aslDropdown = useSelector(
    (state) => state.hospitalReducer.aslGetResponse
  );
  // const [showConfirm,setShowConfirm] =useState(false)
  const [viewRoleId, setViewRoleId] = useState();
  const [pharmacyList, setPharmacyList] = useState([]);
  const [pharmacyHeader, setPharmacyHeader] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [progress, setProgress] = useState(33);
  const [currentStep, setCurrentStep] = useState(1);
  const [query, setQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState();
  const [countryDialCode, setCountryDialCode] = useState();
  const [countryCode, setCountryCode] = useState();
  const [isSuccess, setIsSuccess] = useState(false);
  const [viewDetails, setViewDetails] = useState("tableList");
  const [calendarData, setCalendarData] = useState([]);
  const [menuRoleId, setMenuRoleId] = useState();
  const [viewData, setViewdata] = useState(false);
  const [activePharmacy, setActivePharmacy] = useState();
  const [savedData, setSavedData] = useState([]);
  const { t } = useTranslation("translation");
  const [region, setRegion] = useState([]);
  const [retailListData, setRetailListData] = useState({});
  const [dropdownPharamcyData, setDropdownPharamcyData] = useState({});
  const [rowDataView, setViewRowData] = useState({});
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [confirmState, setConfirmState] = useState({
    visible: false,
    message: "",
    action: null,
  });
  const [calendarValue, setCalendarValue] = useState([]);
  const weekDays = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
    reset,
    watch,
    trigger,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      ContactAll: [],
      calenderList: [
        {
          startDate: null,
          endDate: null,

          // times: Array(7).fill({ startTime: null, endTime: null, weekDay: null }),
          times: weekDays.map((day) => ({
            weekDay: day,
            startTime: null,
            endTime: null,
          })),
        },
      ],
    },
  });

  watch("Province");
  watch("Address");
  watch("City");
  watch("Region");
  watch("asl");
  watch("Denominazione");
  watch("HospitalNumber");
  watch("vat");
  const { validateField } = useValidation();
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    showLoader,
    hideLoader,
    loadingStepper,
    showStepperLoader,
    hideStepperLoader,
  } = useLoader();
  const activeRouteData = location.pathname.replace("/", "");

  let headerTranslations = {
    name: "DENOMINAZIONE",
    ministerialId: "ID MINISTERIALE",
    asl: "ASL",
    cityName: "CITTA",
    regionName: "REGIONE",
    city: "CITTA",
    region: "REGIONE",
    status: "STATUS",
    vat: "P.IVA",
  };

  const {
    fields: contactFields,
    append: appendContact,
    remove: removeContact,
  } = useFieldArray({
    control,
    name: "ContactAll",
  });
  const {
    fields: calenderFields,
    append: appendCalender,
    remove: removeCalender,
  } = useFieldArray({
    control,
    name: "calenderList",
  });
  const headerOrder = [
    "name",
    "ministerialId",
    "vat",
    "asl",
    "city",
    "region",
    "address",
    "status",
  ];

  const stepConfigs = {
    1: [
      {
        title: "Step 1 of 4",
        titleMain: `${t("text_title_basic")}`,
        textFooter: `${t("text_demographic_data")}`,
        fields: [
          { type: "heading", content: `${t("text_demo_data")}` },
          {
            name: "Denominazione",
            type: "text",
            placeholder: `${t("tex_designation")}*`,
            validation: true,
          },
          {
            name: "ministerialId",
            type: "text",
            placeholder: `ID Ministeriale*`,
            validation: true,
          },
          {
            name: "Region",
            type: "dropdown",
            placeholder: `${t("text_region")}*`,
            validation: true,
          },
          {
            name: "asl",
            type: "dropdown",
            placeholder: `ASL*`,
            validation: true,
            disableArrowIcon: true,
            // disabled: !getValues("Region"),
          },

          {
            name: "City",
            type: "text",
            placeholder: `${t("text_city")}*`,
            validation: true,
          },
          {
            name: "Address",
            type: "text",
            placeholder: `${t("text_address_value")}*`,
            validation: true,
          },
          {
            name: "Province",
            type: "text",
            placeholder: `${t("text_province")}*`,
            validation: true,
            maxLength: true,
          },

          // { type: "heading", content: "Contatto" },
          {
            name: "HospitalNumber",
            type: "phoneNumber",
            placeholder: `${t("text_telephone")}*`,
            validation: true,
          },
          {
            name: "vat",
            type: "text",
            placeholder: "P.IVA",
            validation: true,
          },

          {
            type: "buttonCheck",
            label: `${t("text_button_confirms")}`,
            disabled:
              getValues("Denominazione")?.length == 0 ||
              getValues("asl")?.length == 0 ||
              !getValues("Region")||
              getValues("City")?.length == 0 ||
              getValues("Address")?.length == 0 ||
              getValues("Province")?.length == 0 ||
              !(
                getValues("HospitalNumber")?.slice(countryDialCode?.length)
                  .length >= 10
              ),
          },
        ],
      },
      //
      {
        title: "Step 2 of 4",
        titleMain: t("text_stepper_title_contact"),
        fields: [
          {
            type: "heading-img",
            content: t("text_heading_contact"),
            img: { Search },
          },
        ],
      },
      {
        title: "Step 3 of 4",
        titleMain: t("text_timetables_calendars"),
        textFooter: "Inserisci almeno una Farmacia Ospedaliera di riferimento",
        fields: [
          {
            type: "calender-field",
            content: t("text_calendar"),
            img: { Search },
            previousBtn: true,
          },
        ],
      },

      {
        title: "Step 4 of 4",
        titleMain: `${t("text_structure_summary")}`,
        textFooter: `${t("text_summary_verification")}`,
        fields: [
          // { type: "heading", content: `${t("text_new_administrator_data")}` },
          { type: "hospitalsummary", content: "" },

          { type: "buttonsRowConfirm" },
        ],
      },
    ],
  };
  const roleBasedSteps = stepConfigs[1];
  useEffect(() => {
    setCurrentPageNumber(1);
    setItemsPerPage(10);
  }, [activeRouteData]);
  useEffect(() => {
    var headers = {
      pageNo: currentPageNumber,
      pageSize: itemsPerPage,
      pharmacyType: "retail",
      isCurrentUser: String(false),
      ...(query ? { filter: query } : {}),
    };

    dispatch(getPharmacyRetail(headers, showLoader, hideLoader));
    let headersupdate = {
      isAll: true,
    };
    let addASLObject = { headersupdate, showLoader, hideLoader, showToast, t };
    dispatch(getAsl(addASLObject));
  }, [activeRouteData, itemsPerPage, currentPageNumber]);

  const onStructureStatusChange = (selectedData) => {
    const headers = {
      AccessIdentifier: "validate",
    };
    const payload = {
      id: selectedData?.id,
      isActive: !selectedData?.isActive,
    };
    dispatch(
      updateStatusRetail(
        selectedData?.id,
        payload,
        headers,
        showLoader,
        hideLoader,
        showToast,
        t,
        selectedData?.id
      )
    );
    viewDetails && setViewDetails("tableList");
  };
  const handleRegisterData = (rowData) => {
    setRetailListData(rowData);
    setViewRowData(rowData);
    if (
      rowData?.action === "Attiva/DisattivaRetail" &&
      (rowData?.isActive === true || rowData?.isActive === false)
    ) {
      onStructureStatusChange(rowData);
      return;
    }

    setProgress(33);
    setCurrentStep(1);
    setIsSuccess(false);
    setActivePharmacy(rowData);

    if (rowData?.action === "Attiva Assistito") {
      // setModalActiveReg(true)
    } else if (rowData?.action === "Elimina Assistito") {
      // setShowConfirm(true);
    } else if (rowData?.action === "Modifica Retail") {
      if (rowData?.isActive == true) {
        let id = rowData?.id;
        setViewRoleId(id);
        dispatch(getByRetailId(rowData?.id, showLoader, hideLoader,showToast,t));
        setViewDetails("editData");
      } else {
        showToast(
          "warn",
          "Attenzione",
          "Una volta che i dati sono attivi, è possibile modificare le modifiche"
        );
        return;
      }
    }
  };

  const totalPages = Math.ceil(pharmacyInfo?.totalCount / itemsPerPage);

  useEffect(() => {
    const data = pharmacyInfo?.result?.map(({ id, ...rest }) => rest);
    setPharmacyList(pharmacyInfo?.result);
    let initialValue = data?.[0];
    let headerData = initialValue
      ? Object.keys(initialValue).map((item) => item)
      : [];

    const excludeHeaders = [
      "id",
      "address",
      "city",
      "region",
      "pharmacyTypeId",
      "pharmacyTypeName",
    ];
    const filteredTableHeader = headerData?.filter(
      (col) => !excludeHeaders.includes(col)
    );
    const filterHeader = [
      "name",
      "ministerialId",
      "vat",
      "asl",
      "region",
      "city",
      "status",
    ];
    setPharmacyHeader(filterHeader);
  }, [pharmacyInfo, pharmacyList]);

  useEffect(() => {
    let year = "2024";
    let regionCode = "";
    let header={
      isAll:true
    }
    dispatch(getRegion(year, regionCode,header));
  }, []);

  useEffect(() => {
    const dataValue = regionDropdown?.result
      ?.map((obj) => {
        if (obj.regionCode == getValues("Region")) {
          return obj.regionName;
        }
        return null;
      })
      .filter((name) => name !== null);
    if (dataValue && dataValue?.length > 0) {
      setRegion(dataValue);
    }
  }, [getValues("Region")]);

  const handleRegister = () => {
    setIsModalOpen(true);
    // setIsSuccess(false)
    setCurrentStep(1);
    setProgress(33);
    let headersupdate = {
      isAll: true,
    };
    let addASLObject = { headersupdate, showLoader, hideLoader, showToast, t };
    dispatch(getAsl(addASLObject));

    // showStepperLoader()
    // let headers = {
    //   pharmacyType: "retail",
    //   isCurrentUser: String(true),
    // };
    // dispatch(getPharmacyRetail(headers, showLoader, hideLoader));
  };
  const handlePreviousPage = (pageValue) => {
    setCurrentPageNumber(pageValue);
  };

  const handleNextPage = (pageValue) => {
    setCurrentPageNumber(pageValue);
  };

  const isValueMissing = (key) => {
    const value = getValues(key);
    return value === undefined || value === null || value?.length === 0;
  }
  
  const handleModalClose = () => {
    let isAnyValueMissing = isValueMissing("Denominazione") &&
      isValueMissing("asl") &&
      isValueMissing("Region") &&
      isValueMissing("City") &&
      isValueMissing("Address") &&
      isValueMissing("Province") &&
      isValueMissing("HospitalNumber");
    if (isAnyValueMissing || isSuccess ) {
      setIsModalOpen(false);
      reset();
      setSavedData([]);
      setIsSuccess(false);
      setCalendarValue([]);
      setCalendarData([])
    } else {
      showConfirm("Se chiudi il modale, perderai i dati.", () => {
        setIsModalOpen(false);
        reset();
        reset();
        setSavedData([]);
        setCalendarValue([]);
        setCalendarData([])
        let year = "2024";
        let regionCode = "";
        let header={
          isAll:true
        }
        dispatch(getRegion(year, regionCode,header));
      });
    }
    // setIsModalOpen(false);
    // onReset();

    // reset();
    hideStepperLoader();
    setQuery("");
    // setSavedData([])
  };
  const handleCloseSubmission = () => {
    setIsModalOpen(false);
    setIsSuccess(false);
    reset();
    setSavedData([]);
    setCalendarValue([]);
    setCalendarData([])
    setQuery("");
     let year = "2024";
        let regionCode = "";
        let header={
          isAll:true
        }
        dispatch(getRegion(year, regionCode,header));
  };
  const handleModalSubmit = () => {
    // console.log("check11");
  };
  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
  };

  const handleCountryChange = (data) => {
    setCountryDialCode(data?.dialCode);
    setCountryCode(data?.countryCode);
  };

  // const handleSubmitStep = () => {
  //   setIsNextClicked(true)
  //   //   dispatch(createPatient(payload,showLoader,hideLoader,setIsSuccess,showToast,t));
  //   };
  const fieldValues = getValues("ContactAll")?.filter(
    (item) =>
      item !== null &&
      Object.values(item).every(
        (value) => value !== null && value !== undefined && value !== ""
      )
  );
  // const filedCalendar = getValues("calenderList")?.filter(
  //   (item) =>
  //     item !== null &&
  //     Object.values(item).every(
  //       (value) => value !== null && value !== undefined && value !== ""
  //     )
  // );
  const filedCalendar = calendarData?.filter(
    (item) =>
      item !== null &&
      Object.values(item).every(
        (value) => value !== null && value !== undefined && value !== ""
      )
  );
  const handleSubmitStep = () => {
    if (viewData === true) {
      setIsModalOpen(false);
    } else {
      var payload = {
        ministerialId: getValues("ministerialId"),
        name: getValues("Denominazione"),
        asl: getValues("asl"),
        region: region?.[0],
        address: getValues("Address"),
        city: getValues("City"),
        cap: "10007",
        province: getValues("Province"),
        // phoneNumber: `+${countryDialCode}  ${getValues("HospitalNumber")?.slice(
        //   countryDialCode.length
        // )}`,
        phoneNumber:`${extractPhoneNumber(countryDialCode,getValues("HospitalNumber"))}`,
        countryCode: countryCode.toUpperCase(),
        pharmacyType: "retail",
        isActive: true,
        vat: getValues("vat")||0,
        //  "validFrom": formatDate(getValues('calenderList')[0].startDate),
        //  "validTo": formatDate(getValues('calenderList')[0].endDate),
        // contacts: fieldValues.map((contactValue, index) => ({
        //   contactName: contactValue.field1,
        //   contactSurname: contactValue.field2,
        //   role: contactValue.field3,
        //   phoneNumber: contactValue.field4,
        //   isActive: true,
        // })),
        Contacts:savedData.map((contactValue,index)=>({
          contactName: contactValue.field1,
          contactSurname: contactValue.field2,
          role: contactValue.field3,
          phoneNumber: contactValue.field4,
          isActive: true,
        })),
        calendars: filedCalendar.map((calendarValue) => ({
          PharmacyId: 0,
          startDate: formatDate(calendarValue.startDate),
          endDate: formatDate(calendarValue.endDate),
          weekDaySessions: calendarValue?.times.map((time, index) => ({
            weekDay:
              time.weekDay == "Lun"
                ? "monday"
                : time.weekDay == "Mar"
                ? "tuesday"
                : time.weekDay == "Mer"
                ? "wednesday"
                : time.weekDay == "Gio"
                ? "thursday"
                : time.weekDay == "Ven"
                ? "friday"
                : time.weekDay == "Sab"
                ? "saturday"
                : "sunday",
            sessionType: "session1",
            openTime: formatTime(time.startTime),
            closeTime: formatTime(time.endTime),
            isSpecialDay: false,
            date: null,
            isClosed: false,
          })),
        })),
      };


      dispatch(
        createHospitalRetail(
          payload,
          showLoader,
          hideLoader,
          setIsSuccess,
          showToast,
          t
        )
      );
     
    }
  };
  const handleViewData = (rowData) => {
    let id = rowData?.id;
    setViewDetails("viewData");
    setViewRoleId(id);
    setRetailListData(rowData);
    setViewRowData(rowData);
    dispatch(getByRetailId(rowData?.id, showLoader, hideLoader, showToast, t));
    let headersupdate = {
      isAll: true,
    };
    let addASLObject = { headersupdate, showLoader, hideLoader, showToast, t };
    dispatch(getAsl(addASLObject));
  };
  const handlePreviousList = () => {
    setViewDetails("tableList");
  };
  const tabContents = [
    {
      key: "ANAGRAFICA",
      content: (
        <>
          <RetailView
            retailListData={retailListData}
            rowDataView={rowDataView}
            pharmacyViewData={pharmacyViewData}
            regionDropdown={regionDropdown}
            viewDetails={viewDetails}
            aslDropdown={
              aslRegionDropdown?.result?.length > 0
                ? aslRegionDropdown?.result
                : []
            }
            handlePreviousList={handlePreviousList}
          />
        </>
      ),
    },
    {
      key: "CONTATTI DI RIFERIMENTO",
      content: (
        <HospitalRetailContact
          pharmacyViewData={pharmacyViewData}
          regionDropdown={regionDropdown}
          rowDataView={rowDataView}

        />
      ),
    },
    {
      key: "FARMACIE",
      content: (
        <FarmacieInsertionRetail
          pharmacyViewData={pharmacyViewData}
          retailListData={retailListData}
          rowDataView={rowDataView}

        />
      ),
    },
  ];

  const items = [
    { label: `${t("text_personal_data_structure")}` },
    { label: `${t("text_contact_reference_structure")}` },
    { label: `${t("text_calendars")}` },
  ];

  const handleSearch = useCallback(
    debounce((value) => {
      setCurrentPageNumber(1)
      var headers = {
        pageNo: currentPageNumber,
        pageSize: itemsPerPage,
        filter: value.trim(),
        pharmacyType: "retail",
      };
      // Trigger the search only if length of the input is 3 or more
      if (value.trim().length >= 3) {
        dispatch(getPharmacyRetail(headers, showLoader, hideLoader));
      }
      if (value.trim().length == 0) {
        dispatch(getPharmacyRetail(headers, showLoader, hideLoader));
      }
    }, 500),
    [itemsPerPage]
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    handleSearch(value);
  };

  const menuData = "Retail";
  const handleItemsPerPage = (itemsPerPage) => {
    setItemsPerPage(itemsPerPage);
    setCurrentPageNumber(1);
  };
  const showConfirm = (message, action) => {
    setConfirmState({
      visible: true,
      message,
      action,
    });
  };
  const hideConfirm = () => {
    setConfirmState({ visible: false, message: "", action: null });
  };
  const onConfirm = () => {
    if (confirmState.action) {
      confirmState.action();
    }
    hideConfirm();
  };
  const handlePageClick = (page) => {
    setCurrentPageNumber(page);
  };
  useEffect(() => {
    const selectedRegion = regionDropdown?.result?.find(
      (region) => region.regionCode == getValues("Region")
    );
    if (selectedRegion) {
      setValue("asl", "");
      let year = "2024";
      let regionCode = selectedRegion.regionCode;
      let header={
        isAll:true
      }
      dispatch(getRegion(year, regionCode,header));
    }
  }, [getValues("Region")]);

  return (
    <>
      <div className="dashboard-content mt-2">
        <div className="d-flex justify-content-between align-items-center me-3 ml-5">
          <div className="d-flex align-items-center">
            {viewDetails==="editData" || viewDetails==="viewData"  ? (
              <>
                <DynamicBreadcrumbs
                  handlePreviousList={handlePreviousList}
                  menuData={menuData}
                />
              </>
            ) : (
              <h4 className="secondary-text-color fw-bold ms-4">
                {/* {t("menu_retail_supervisor")?.toUpperCase()} */}
                FARMACIE RETAIL
              </h4>
            )}
          </div>
          {viewDetails==="tableList" && (
            <div className="search-input-width p-input-icon-left">
              <img
                src={SearchLogo}
                alt="Search Icon"
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "20px",
                  height: "20px",
                }}
              />
              <InputText
                value={query}
                onChange={handleChange}
                placeholder="Cerca assistito per nome, Codice Fiscale..."
                className="w-100 input-with-icon pl-5"
                style={{ paddingLeft: "30px" }}
              />
            </div>
          )}
          {viewDetails==="tableList" &&<CommonButton
            icon={true}
            // label={t("text_structure_create")?.toUpperCase()}
            label={"NUOVA FARMACIE RETAIL"}
            inputStyle={true}
            className="btn btn-success padding-align input-style-common text-white me-3"
            type="button"
            variant="success"
            onClick={() => handleRegister()}
          />}
        </div>
        {(viewDetails==="editData" || viewDetails==="viewData")  && (
          <div className="mt-6 p-0">
            {/* //   <p>sdfsf</p> */}

            <CommonTab
              model={items}
              tabContents={tabContents}
              handlePreviousList={handlePreviousList}
              viewRoleId={viewRoleId}
              structureViewData={pharmacyViewData}
            />
            {/* <PatientView /> */}
          </div>
        )}
        {pharmacyList?.length > 0 &&
        viewDetails==="tableList" &&
        regionDropdown?.result?.length > 0 ? (
          <div className="mt-5 rounded-card">
            <CommmonTable
              dataContent={pharmacyList}
              tableHeader={pharmacyHeader}
              showViewButton={true}
              showDeleteButton={true}
              onViewData={handleViewData}
              onRegisterData={handleRegisterData}
              setIsModalOpen={setIsModalOpen}
              getValues={getValues}
              setValue={setValue}
              register={register}
              control={control}
              checkboxStatus={true}
              handlePreviousPage={handlePreviousPage}
              handleNextPage={handleNextPage}
              headerTranslations={headerTranslations}
              totalItems={pharmacyInfo?.totalCount}
              currentPage={currentPageNumber}
              totalPages={totalPages}
              aslDropdown={
                regionDropdown?.result?.length > 0 && regionDropdown?.result
              }
              loading={loading}
              headerOrder={headerOrder}
              popupOptionRetail={true}
              activePatientData={activePharmacy}
              itemsPerPage={itemsPerPage}
              handleItemsPerPage={handleItemsPerPage}
              handlePageClick={handlePageClick}
            />
          </div>
        ) :viewDetails==="tableList" ? (
          <p
            className="text-center mt-6"
            style={{ backgroundColor: "transparent" }}
          >
            <img src={noData} />
          </p>
        ) : (
          ""
        )}
        {isModalOpen && regionDropdown?.result?.length > 0 && (
          <StepperModal
            screen={"HospitalRetail"}
            isModalOpen={isModalOpen}
            handleModalClose={handleModalClose}
            currentStep={currentStep}
            progress={progress}
            getValues={getValues}
            isSuccess={isSuccess}
            control={control}
            errors={errors}
            register={register}
            validateField={validateField}
            handleCloseSubmission={handleCloseSubmission}
            watch={watch}
            roleBasedSteps={roleBasedSteps}
            onSubmit={handleSubmit(handleModalSubmit)}
            onChange={handlePhoneChange}
            onCountryChange={handleCountryChange}
            handleSubmitStep={handleSubmitStep}
            trigger={trigger}
            calendarData={calendarData}
            setCalendarData={setCalendarData}
            setProgress={setProgress}
            setCurrentStep={setCurrentStep}
            fields={contactFields}
            append={appendContact}
            remove={removeContact}
            fieldsCalender={calenderFields}
            appendCalender={appendCalender}
            removeCalender={removeCalender}
            savedData={savedData}
            setSavedData={setSavedData}
            setValue={setValue}
            regionName={region}
            //   dropdownOptions={
            //     (menuRoleId?.[0] === 3 || menuRoleId?.[0] === 4) &&
            //     hospitalPharmacyDropdown?.length > 0
            //       ? hospitalPharmacyDropdown
            //       : menuRoleId?.[0] === 5 && hospitalFacilityDropdown?.length > 0
            //       ? hospitalFacilityDropdown
            //       : []
            //   }
            mainTitle={t("text_heading_retail_insertion")}
            //   menuRoleId={menuRoleId}
            //   errorFlag={errorFlag}
            //   dropdownAll={dropdownAll}
            isUserFlag={true}
            size="xl"
            progressHide={false}
            dropdownOptions={regionDropdown.result}
            countryDialCode={countryDialCode}
            hospitalRetailSuccess={true}
            aslDropdown={
              aslRegionDropdown?.result?.length > 0
                ? aslRegionDropdown?.result
                : []
            }
            dropdownPharamcyData={dropdownPharamcyData}
            setDropdownPharamcyData={setDropdownPharamcyData}
            calendarValue={calendarValue}
            setCalendarValue={setCalendarValue}
            // disabled={viewData ? true :false }
          />
        )}

        <ConfirmAlert
          visible={confirmState.visible}
          onHide={hideConfirm}
          message={confirmState.message}
          onConfirm={onConfirm}
        />
        {!loadingStepper && <CommonLoader loading={loading} />}
      </div>
    </>
  );
};
export default HospitalRetail;
